import * as React from 'react';
import { styles } from "./styles.js";
import { useQrReader } from "./hooks.js";
export const QrReader = ({
  videoContainerStyle,
  containerStyle,
  videoStyle,
  constraints,
  ViewFinder,
  scanDelay,
  className,
  onResult,
  videoId
}) => {
  useQrReader({
    constraints,
    scanDelay,
    onResult,
    videoId
  });
  return /*#__PURE__*/React.createElement("section", {
    className: className,
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    style: { ...styles.container,
      ...videoContainerStyle
    }
  }, !!ViewFinder && /*#__PURE__*/React.createElement(ViewFinder, null), /*#__PURE__*/React.createElement("video", {
    muted: true,
    id: videoId,
    style: { ...styles.video,
      ...videoStyle,
      transform: (constraints === null || constraints === void 0 ? void 0 : constraints.facingMode) === 'user' && 'scaleX(-1)'
    }
  })));
};
QrReader.displayName = 'QrReader';
QrReader.defaultProps = {
  constraints: {
    facingMode: 'user'
  },
  videoId: 'video',
  scanDelay: 500
};